export default __webpack_public_path__ + "static/media/icon_camera.c02e1b1c.svg";